import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Form, Input, InputGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap'
import "./customersStyle.css"
import {  Customer, NewCustomer, validateCustomer } from '../../backoffice/dtos/customer/customer'
import { useAddCustomerMutation } from '../../backoffice/apis/customerAPI'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

const CustomerSearch = (
    {
        searchTerm,
        setSearchTerm,
        isLoading,
        openCustomerModal
    }:{
        searchTerm: string,
        setSearchTerm: (value: string) => void
        isLoading: boolean
        openCustomerModal: (customer ?: Customer) => void
    }
) => {

    const {t} = useTranslation(['customers', 'common'])
    const [debouncedTerm, setDebouncedTerm] = useState<string>(searchTerm)

    useEffect(() => {
        const timer = setTimeout(() => setSearchTerm(debouncedTerm), 800);
        return () => clearTimeout(timer);
    }, [debouncedTerm])

    return (
            <Row className='mt-1 gy-1'>
                <Col className='d-flex flex-column justify-content-center'>
                    <Form>
                        <InputGroup>
                            <Input type='text' placeholder= {t('search',{ns:'common'})} onChange={(e) => setDebouncedTerm(e.target.value)} />
                            <Button>
                                <span className="fa fa-search bg- fa-lg" ></span>
                            </Button>
                        </InputGroup>
                    </Form>
                </Col>
                <Col lg='auto' className="d-flex flex-column align-items-end">
                    <Button color='primary' onClick={() => openCustomerModal(undefined)} disabled={isLoading}>
                        <span className='fa fa-lg fa-plus' /> {t('Add', { ns: 'common' })}{isLoading && <Spinner size='sm' className='ms-2'/>}
                    </Button>
                </Col>
            </Row>
    )
}

export default CustomerSearch
